import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MenuItem } from './../../../models/menu/menu.model';

@Injectable()
export class MenuService {
  private _reloadRequested = new Subject<MenuItem>();
  public reloadRequested = this._reloadRequested.asObservable();

  constructor() { }


  public reload(item: MenuItem) {
    this._reloadRequested.next(item);
  }

}
